import lamejs from "@breezystack/lamejs";
import { audioBufferToWav } from "./wav";

function floatToInt16(f) {
  const o = new Int16Array(f.length);
  for (let i = 0; i < f.length; i++) {
    let s = Math.max(-1, Math.min(1, f[i]));
    o[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
  }
  return o;
}

export function encodeMp3(buffer, kbps = 192) {
  const ch = Math.min(2, buffer.numberOfChannels);
  const sr = buffer.sampleRate;
  const enc = new lamejs.Mp3Encoder(ch, sr, kbps);
  const left = floatToInt16(buffer.getChannelData(0));
  const right = ch > 1 ? floatToInt16(buffer.getChannelData(1)) : left;
  const block = 1152;
  const data = [];
  for (let i = 0; i < left.length; i += block) {
    const l = left.subarray(i, i + block);
    const r = right.subarray(i, i + block);
    const mp3 = ch > 1 ? enc.encodeBuffer(l, r) : enc.encodeBuffer(l);
    if (mp3.length) data.push(new Int8Array(mp3));
  }
  const end = enc.flush();
  if (end.length) data.push(new Int8Array(end));
  return new Blob(data, { type: "audio/mpeg" });
}

export function pickMime(format) {
  const has = typeof MediaRecorder !== "undefined" && MediaRecorder.isTypeSupported;
  if (!has) return null;
  if (format === "WebM") {
    for (const m of ["audio/webm;codecs=opus", "audio/webm"]) if (MediaRecorder.isTypeSupported(m)) return m;
  }
  if (format === "OGG") {
    for (const m of ["audio/ogg;codecs=opus", "audio/ogg"]) if (MediaRecorder.isTypeSupported(m)) return m;
  }
  return null;
}

export async function recordToBlob(buffer, mime) {
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  const dest = ctx.createMediaStreamDestination();
  const src = ctx.createBufferSource();
  src.buffer = buffer;
  src.connect(dest);
  const rec = new MediaRecorder(dest.stream, { mimeType: mime });
  const chunks = [];
  rec.ondataavailable = (e) => { if (e.data.size) chunks.push(e.data); };
  const done = new Promise((r) => (rec.onstop = r));
  rec.start();
  src.start();
  await new Promise((r) => (src.onended = r));
  setTimeout(() => rec.state !== "inactive" && rec.stop(), 150);
  await done;
  await ctx.close();
  return new Blob(chunks, { type: mime });
}

export async function encodeToFormat(buffer, format, bitDepth) {
  if (format === "MP3") return { blob: encodeMp3(buffer), ext: "mp3" };
  if (format === "WAV") return { blob: audioBufferToWav(buffer, bitDepth), ext: "wav" };
  const mime = pickMime(format);
  if (!mime) return { blob: audioBufferToWav(buffer, bitDepth), ext: "wav", fallback: true };
  const blob = await recordToBlob(buffer, mime);
  const ext = format === "OGG" && mime.includes("ogg") ? "ogg" : "webm";
  return { blob, ext };
}
